<script lang="ts">
  import { Link } from "svelte-routing";
  import { Footer } from 'svelte-materialify';

  import { Icon } from 'svelte-materialify';
  import { mdiInstagram } from '@mdi/js';

  import { ROUTES } from "./routes/routes"
</script>

<style>
</style>




<div style="height: 200px;position:relative;">
  <Footer class="justify-center pa-2" absolute>
    <a href="https://www.instagram.com/riel030/" target="_blank">
      <Icon path={mdiInstagram} /> by rieL
    </a>
    &nbsp;&nbsp;&nbsp;–&nbsp;&nbsp;&nbsp;
    <Link to={ROUTES.IMPRINT}>imprint</Link>
  </Footer>
</div>
